import { createContext, useContext, useReducer } from 'react'
import { reducer } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'

localStorage.setItem('showAttributes', false)
localStorage.setItem('showRelevantMetaNodes', false)
localStorage.setItem('showAllMetaNodes', false)

const initialState = {
  visToWvrMap: {},                      // VIS ID KEYS WITH WVR NODES VALUES
  canonicalNodeIds: [],                   // POPULATED FROM WEAVER QUERY
  isAddingEdge: false,
  groups: {
    "undefined": {
      color: "#EEEEEE"
    }
  },
  creatingEdgeProps: undefined,
  renameRelationProps: undefined,
  colorPickerProps: undefined,
  selectedGraphItems: undefined,
  showAttributes: false,
  showRelevantMetaNodes: false,
  showAllMetaNodes: false,
  queryResults: [],
  richNodesMap: {}
}

const GraphContext = createContext(initialState)

export const GraphContextProvider = ({ children }) => {
  const isMounted = useComponentIsMountedRef()
  const [state, dispatch] = useReducer(reducer, initialState)

  const protectedDispatch = (...args) => {
    if (!isMounted.current) {
      return
    }
    dispatch(...args)
  }

  return (
    <GraphContext.Provider value={[state, protectedDispatch]}>
      { children }
    </GraphContext.Provider>
  )
}

export const useGraphData = () => useContext(GraphContext)
